import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { IGutterAsMarginProps, useGutterAsMarginCss } from '../../fundamentals/spaces/space';
import { IActionCssProps, useActionCss } from '../../fundamentals/actions';
import { IllustrationName } from './illustrations';
import { EoraAssetsContext } from '../../themes/EoraThemeProvider';
import { BaseImg } from '../../common/BaseElements';

export interface IIllustrationProps extends IGutterAsMarginProps, Pick<React.HTMLProps<HTMLImageElement>, 'key'> {
  name: IllustrationName;
}

const useIllustrationBaseCss = css<IIllustrationProps & IActionCssProps>`
  ${useActionCss};
  ${useGutterAsMarginCss()};
`;

export const Illustration = styled(BaseImg).attrs<IIllustrationProps>(({ name, onClick, ...rest }) => {
  const { generateTestId } = useTestId(rest, `Illustration`);
  const { baseAssetsUrl } = useContext(EoraAssetsContext);

  const src = `${baseAssetsUrl}/images/il/${name}.svg`;
  return {
    src,
    ...generateTestId(name),
    name: undefined
  };
})<IIllustrationProps>`
  ${useIllustrationBaseCss};
`;
